export default Object.freeze({
  MAX: 999,
  MIN: 0,
});
